module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirmDelete,
      "showFooter": true,
      "title": _vm.getTranslation('modal_confirm_title'),
      "body": _vm.getTranslation('label_confirm_client_file_delete')
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirmDelete(false)
      },
      "confirmYes": function($event) {
        _vm.confirmDelete(true)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('call-settings', {
    attrs: {
      "client": _vm.client
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.hideTitle) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_edit_headline')) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_name')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.clientName),
      expression: "client.clientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clientName",
      "formControlName": "clientName"
    },
    domProps: {
      "value": (_vm.client.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.clientName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_first_name')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.user.firstName),
      expression: "client.user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstName",
      "formControlName": "firstName"
    },
    domProps: {
      "value": (_vm.client.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.user.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_last_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.user.lastName),
      expression: "client.user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastName",
      "formControlName": "lastName"
    },
    domProps: {
      "value": (_vm.client.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.user.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_user_mail')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.user.email),
      expression: "client.user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "formControlName": "email"
    },
    domProps: {
      "value": (_vm.client.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_username')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.username),
      expression: "client.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "formControlName": "username"
    },
    domProps: {
      "value": (_vm.client.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "hotline-number"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_hotlineNumber')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotlineNumber),
      expression: "hotlineNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "hotline-number",
      "formControlName": "hotline-number"
    },
    domProps: {
      "value": (_vm.hotlineNumber)
    },
    on: {
      "keyup": function($event) {
        _vm.validatePhoneNum($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hotlineNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "twilioAccountSid"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_twilioAccountSid')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.twilioAccountSid),
      expression: "client.twilioAccountSid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "twilioAccountSid",
      "formControlName": "twilioAccountSid"
    },
    domProps: {
      "value": (_vm.client.twilioAccountSid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.twilioAccountSid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "twilioAccountToken"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_twilioAccountToken')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.twilioAccountToken),
      expression: "client.twilioAccountToken"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "twilioAccountToken",
      "formControlName": "twilioAccountToken"
    },
    domProps: {
      "value": (_vm.client.twilioAccountToken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.twilioAccountToken = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_clientApiToken')))]), _vm._v(" "), (_vm.client.clientApiToken) ? _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.client.clientApiToken),
      expression: "client.clientApiToken",
      arg: "copy"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('lbl_copy')) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.client.clientApiToken) ? _c('span', [_vm._v(_vm._s(_vm.getTranslation('lbl_none_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "langSelector"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_language')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.dropClose),
      expression: "dropClose"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpened
    },
    attrs: {
      "id": "langSelector"
    }
  }, [_c('button', {
    staticClass: "dropdown-toggle form-control",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dropToggle($event)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.getTranslation(_vm.labelLangString)) + "\n                                "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": _vm.dropToggle
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setClientLanguage('de');
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_deutsch')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setClientLanguage('en');
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_english')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group same-row-spaced-apart-aligned",
    staticStyle: {
      "margin": "2.5rem 0"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_activate_customers')))]), _vm._v(" "), _c('app-switch', {
    attrs: {
      "autoSave": true,
      "isInList": false,
      "identification": "useCustomers"
    },
    model: {
      value: (_vm.useCustomers),
      callback: function($$v) {
        _vm.useCustomers = $$v
      },
      expression: "useCustomers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('lbl_upload_files')))]), _vm._v(" "), (_vm.showUploadForm) ? _c('banet-upload', {
    ref: "banetUpload",
    staticClass: "well",
    attrs: {
      "autoUpload": true
    },
    on: {
      "setFiles": _vm.setFiles,
      "tempFiles": _vm.setTempFiles
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.audioDisplay) ? _c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": ("/history/files/" + (_vm.$route.params.id)),
      "activeClass": "active",
      "tag": "button",
      "title": _vm.getTranslation('lbl_history_sounds')
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_onDutyFile')))]), _vm._v(" "), (_vm.client.onDutyFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.onDutyFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview0'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview0')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview0'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview0",
    attrs: {
      "id": "audio_onDutyFile",
      "src": _vm.filePath + 'getondutyfile' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview0')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('onDutyFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_offDutyFile')))]), _vm._v(" "), (_vm.client.offDutyFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.offDutyFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview1'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview1')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview1'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview1",
    attrs: {
      "id": "audio_offDutyFile",
      "src": _vm.filePath + 'getoffdutyfile' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview1')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('offDutyFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_disturbFile')))]), _vm._v(" "), (_vm.client.disturbFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.disturbFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview2'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview2')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview2'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview2",
    attrs: {
      "id": "audio_disturbFile",
      "src": _vm.filePath + 'disturb' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview2')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('disturbFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true",
      "title": _vm.getTranslation('lbl_delete')
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_helpFile')))]), _vm._v(" "), (_vm.client.helpFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.helpFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview3'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview3')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview3'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview3",
    attrs: {
      "id": "audio_helpFile",
      "src": _vm.filePath + 'helptext' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview3')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('helpFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_acceptedFile')))]), _vm._v(" "), (_vm.client.acceptedFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.acceptedFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview4'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview4')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview4'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview4",
    attrs: {
      "id": "audio_acceptedFile",
      "src": _vm.filePath + 'accepted' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview4')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('acceptedFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_deniedFile')))]), _vm._v(" "), (_vm.client.deniedFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.deniedFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview5'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview5')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview5'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview5",
    attrs: {
      "id": "audio_deniedFile",
      "src": _vm.filePath + 'denied' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview5')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('deniedFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_invalidFile')))]), _vm._v(" "), (_vm.client.invalidFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.invalidFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview6'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview6')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview6'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview6",
    attrs: {
      "id": "audio_invalidFile",
      "src": _vm.filePath + 'invalid' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview6')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('invalidFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_client_inputCode')))]), _vm._v(" "), (_vm.client.codeFile) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                    " + _vm._s(_vm.client.codeFile) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview7'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview7')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview7'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview7",
    attrs: {
      "id": "audio_codeFile",
      "src": _vm.filePath + 'code' + _vm.fileLinkVar
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview7')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfirmDialog('codeFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.translations.lbl_save) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.translations.app_lbl_action_cancel) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('headline_change_password')))]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "chnPsw"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePsw($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "psw_set_1"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('frm_lbl_new_password_1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordNew),
      expression: "passwordNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "psw_set_1",
      "formControlName": "psw_set_1"
    },
    domProps: {
      "value": (_vm.passwordNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "psw_set_2"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('frm_lbl_new_password_2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatPasswordNew),
      expression: "repeatPasswordNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "psw_set_2",
      "formControlName": "psw_set_2"
    },
    domProps: {
      "value": (_vm.repeatPasswordNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPasswordNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getTranslation('btn_lbl_save_new_password')) + "\n                        ")])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d8b6a68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/clients/ClientEdit.vue
// module id = 664
// module chunks = 0